import { ApicallOption, ApicallService } from "@core-services/apicall.service";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { catchError, map } from "rxjs/operators";
import { BasicApiObject, Helper, parseApiResponseArray, parseApiResponseObject } from "@helpers/functions";
import {
	PaymentOption,
	PaymentOptionAdapter
} from "@modules/+new/payments/features/payment-options/domain/entities/payment-option.model";
import { PaymentOptionDto } from "@modules/+new/payments/features/payment-options/infrastructure/dto/payment-option.dto";
import { Limits, LimitsAdapter } from "@modules/+new/payments/shared-payments/entities/limits.model";
import { LimitsDto } from "@modules/+new/payments/shared-payments/dto/limits.dto";

@Injectable({
	providedIn: "any"
})
export class PaymentOptionsRemote {
	private paymentOptionAdapter: PaymentOptionAdapter = new PaymentOptionAdapter();
	public constructor(private readonly apiCallService: ApicallService) {}

	public getPaymentOptions$(): Observable<PaymentOption[]> {
		const option = new ApicallOption();
		option.apiVersion = "v5";
		return this.apiCallService.get("paymentoptions", option).pipe(
			catchError((error: unknown) => Helper.handleError$(error)),
			map((options: BasicApiObject[]) => parseApiResponseArray<PaymentOptionDto>(options)),
			map((options: PaymentOptionDto[]) => this.paymentOptionAdapter.adaptMany(options)),
			map((options: PaymentOption[]) => options.sort((p1: PaymentOption, p2: PaymentOption) => p1.sort - p2.sort))
		);
		// Error should be catched like in ApicallService.handleErrorSideEffects
	}

	public getLimit$(paymentOptionId: number, fiatId: number): Observable<Limits> {
		const options = this.prepareGetLimitsOptions(paymentOptionId, fiatId);
		return this.apiCallService.post("user/limits", options).pipe(
			catchError((error: unknown) => Helper.handleError$(error)),
			map((response: BasicApiObject) => parseApiResponseObject<LimitsDto>(response)),
			map((response: LimitsDto) => new LimitsAdapter().adapt(response))
		);
	}

	private prepareGetLimitsOptions(paymentOptionId: number, fiatId: number): ApicallOption {
		return new ApicallOption(null, {
			type: "deposit",
			payment_option_id: paymentOptionId?.toString(),
			fiat_id: fiatId?.toString()
		});
	}
}
